module.exports = __webpack_public_path__ + "static/media/search.88359084.svg";